jQuery(function() {
    $(document).on('click', '.formLidActionHeader a', function(e) {
        e.preventDefault();
        $(this).remove();
        $('.formLidActionFooter').addClass('active');
    });
    $(document).on('click', '.lidAction #submitLidAction', function(e) {
        e.preventDefault();

        $('#nameLidAction').removeClass('form__input--error');
        $('#phoneLidAction').removeClass('form__input--error');

        $('.error-phone').removeClass('error');
        $('.error-name').removeClass('error');

        let nameForm = $('#nameLidAction').val();
        let phoneForm = $('#phoneLidAction').val();
        let urlForm = location.href;

        if (nameForm && phoneForm) {
            $.ajax({
                type: 'POST',
                url: '/ajax/action/action_detail/ajaxlid/',
                data: {
                    name: nameForm,
                    phone: phoneForm,
                    url: urlForm
                },
                success: function(response) {
                    if (response.message == "ok") {
                        $('.formLidActionFooter').remove();
                        $('.formLidActionResult').html('Спасибо! Заявка отправлена.');
                    }
                }
            });
        }else {
            if (!nameForm) {
                $('#nameLidAction').addClass('form__input--error');
                $('.error-name').addClass('error');
            }
            if(!phoneForm) {
                $('#phoneLidAction').addClass('form__input--error');
                $('.error-phone').addClass('error');
            }
        }
    });
});


// WEBPACK FOOTER //
// ./blocks/action-detail.js